import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _CircularProgress;
var _excluded = ["sx"];
import React from 'react';
import { Box, CircularProgress, extendSX } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This is the Fallback component to render till the module is ready.
 */
export default function FallbackDialogPatientFormJumpLogic(_ref) {
  var sx = _ref.sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Box, _extends({
    sx: extendSX(sx, function (theme) {
      return {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: theme.zIndex.modal
      };
    })
  }, rest, {
    children: _CircularProgress || (_CircularProgress = /*#__PURE__*/_jsx(CircularProgress, {
      size: 32
    }))
  }));
}